(() => {
 'use strict';
 const story=document.querySelector('.zv-scroll-story');
 const canvas=story?.querySelector('.zv-story-liquid');if(!canvas)return;
 const stage=canvas.parentElement;
 const reduce=matchMedia('(prefers-reduced-motion: reduce)');
 function updateProgress(){document.body.dataset.creamScrolled=String(scrollY>24);story.dataset.progress=String(scrollY/Math.max(1,document.documentElement.scrollHeight-innerHeight));}
 function updatePreference(){story.classList.toggle('is-enhanced',!reduce.matches);}
 addEventListener('scroll',updateProgress,{passive:true});
 addEventListener('resize',updateProgress,{passive:true});
 reduce.addEventListener('change',updatePreference);
 updateProgress();updatePreference();
 let gl;try{gl=canvas.getContext('webgl',{alpha:false,antialias:false,depth:false,stencil:false,powerPreference:'low-power'});}catch(e){}
 if(!gl){canvas.dataset.renderer='gradient-fallback';canvas.hidden=true;return;}
 const vertex=`attribute vec2 point;void main(){gl_Position=vec4(point,0.0,1.0);}`;
 const fragment=`
 precision mediump float;
 uniform vec2 size;
 uniform float time;
 uniform float scroll;
 uniform vec2 pointer;
 float surface(vec2 p){
   float t=time*0.085;
   p+=vec2(scroll*.46,-scroll*.25);
   float bend=sin(p.x*1.28-p.y*.84+t)*.7+cos(p.y*1.12+t*.7)*.35;
   float broad=sin(p.y*2.3+p.x*.72+bend-t)*.48;
   float fold=sin(p.x*1.75-p.y*1.1+sin(p.y*1.45+t*.6)*1.0+t*.45)*.32;
   float detail=sin(p.y*4.4+p.x*.5+bend*.9+t*.5)*.075;
   vec2 d=p-pointer;
   float touch=cos(length(d)*3.8-t*1.9)*exp(-dot(d,d)*1.5)*.055;
   return broad+fold+detail+touch;
 }
 void main(){
   vec2 uv=gl_FragCoord.xy/size;
   vec2 p=(uv-.5)*vec2(size.x/size.y,1.0)*3.25;
   float h=surface(p);
   float e=.014;
   vec3 n=normalize(vec3((surface(p-vec2(e,0.0))-surface(p+vec2(e,0.0)))/e,
                        (surface(p-vec2(0.0,e))-surface(p+vec2(0.0,e)))/e,2.35));
   vec3 light=normalize(vec3(-.55,.8,1.3));
   float diff=max(0.0,dot(n,light));
   float sheen=pow(max(dot(n,normalize(light+vec3(0.,0.,1.))),0.),34.);
   float pearl=pow(max(dot(n,normalize(vec3(.7,-.2,1.6))),0.),18.);
   vec3 cream=vec3(.934,.872,.820);
   vec3 rose=vec3(.855,.746,.724);
   float roseAmount=smoothstep(-.4,.75,h)*.28;
   vec3 base=mix(cream,rose,roseAmount);
   vec3 color=base*(.84+diff*.16)+vec3(.98,.94,.89)*sheen*.145+pearl*.023;
   float vignette=smoothstep(.95,.18,length((uv-.5)*vec2(1.,.8)));
   color*=.976+.024*vignette;
   gl_FragColor=vec4(color,1.0);
 }`;
 function shader(type,source){const s=gl.createShader(type);gl.shaderSource(s,source);gl.compileShader(s);if(!gl.getShaderParameter(s,gl.COMPILE_STATUS))throw Error('Background shader could not compile');return s;}
 let program;
 try{program=gl.createProgram();gl.attachShader(program,shader(gl.VERTEX_SHADER,vertex));gl.attachShader(program,shader(gl.FRAGMENT_SHADER,fragment));gl.linkProgram(program);if(!gl.getProgramParameter(program,gl.LINK_STATUS))throw Error('Background could not link');}
 catch(e){canvas.hidden=true;canvas.dataset.renderer='gradient-fallback';return;}
 gl.useProgram(program);
 const buffer=gl.createBuffer();gl.bindBuffer(gl.ARRAY_BUFFER,buffer);gl.bufferData(gl.ARRAY_BUFFER,new Float32Array([-1,-1,1,-1,-1,1,-1,1,1,-1,1,1]),gl.STATIC_DRAW);
 const a=gl.getAttribLocation(program,'point');gl.enableVertexAttribArray(a);gl.vertexAttribPointer(a,2,gl.FLOAT,false,0,0);
 const uniforms=Object.fromEntries(['size','time','scroll','pointer'].map(n=>[n,gl.getUniformLocation(program,n)]));
 let request=0,last=0,elapsed=0,visible=true,lost=false,draws=0;
 let px=0,py=0,tx=0,ty=0;
 const motion=()=>!reduce.matches&&story.classList.contains('is-enhanced')&&!document.hidden&&visible&&!lost;
 function resize(){const box=stage.getBoundingClientRect();const scale=Math.min(1,960/Math.max(box.width,box.height));canvas.width=Math.max(1,Math.round(box.width*scale));canvas.height=Math.max(1,Math.round(box.height*scale));gl.viewport(0,0,canvas.width,canvas.height);render();}
 function render(){if(lost)return;gl.uniform2f(uniforms.size,canvas.width,canvas.height);gl.uniform1f(uniforms.time,elapsed);gl.uniform1f(uniforms.scroll,Number(story.dataset.progress)||0);gl.uniform2f(uniforms.pointer,px,py);gl.drawArrays(gl.TRIANGLES,0,6);canvas.dataset.frames=String(++draws);}
 function tick(now){request=0;if(!motion()){last=0;return;}if(!last||now-last>=32){const dt=last?Math.min((now-last)/1000,.1):0;elapsed+=dt;last=now;px+=(tx-px)*.06;py+=(ty-py)*.06;render();}request=requestAnimationFrame(tick);}
 function sync(){if(request){cancelAnimationFrame(request);request=0;}last=0;canvas.dataset.motion=motion()?'running':'paused';if(motion())request=requestAnimationFrame(tick);}
 stage.addEventListener('pointermove',e=>{const b=stage.getBoundingClientRect();tx=((e.clientX-b.left)/b.width-.5)*(b.width/b.height)*3.25;ty=(.5-(e.clientY-b.top)/b.height)*3.25;},{passive:true});
 stage.addEventListener('pointerleave',()=>{tx=0;ty=0;});
 const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;sync();},{threshold:0});observer.observe(story);
 new MutationObserver(sync).observe(story,{attributes:true,attributeFilter:['class']});
 new ResizeObserver(resize).observe(stage);
 document.addEventListener('visibilitychange',sync);reduce.addEventListener('change',sync);
 canvas.addEventListener('webglcontextlost',e=>{e.preventDefault();lost=true;canvas.hidden=true;canvas.dataset.renderer='gradient-fallback';updatePreference();sync();});
 canvas.dataset.renderer='webgl';updatePreference();resize();sync();
})();
